<template>
  <v-container class="signup-container">
    <validation-observer ref="observer" v-slot="{ handleSubmit, invalid }">
      <form
        ref="form"
        @submit.prevent="handleSubmit(onSubmit)"
        autocomplete="off"
      >
        <v-row justify="center">
          <v-col class="d-flex flex-column" cols="12" sm="6">
            <div class="text-h5 font-weight-bold primary--text">
              <v-icon large color="primary">mdi-account-circle-outline</v-icon>
              Sign up
            </div>

            <span class="text-subtitle-2 font-weight-bold" ref="id">{{
              $t('signup.id')
            }}</span>
            <validation-provider
              ref="email"
              v-slot="{ errors }"
              name="emil"
              rules="required|email"
            >
              <v-text-field
                class="email-input"
                type="email"
                :placeholder="$t('signup.idPlaceholder')"
                v-model.trim="email"
                :error-messages="errors"
                :clearable="!isValidEmail"
                :loading="emailLoading"
                :readonly="emailLoading || isValidEmail"
                @keyup.enter="focusNext($event.target)"
                autocomplete="off"
              >
                <template slot="append">
                  <v-icon v-if="isValidEmail" color="success">mdi-check</v-icon>
                </template>
              </v-text-field>
            </validation-provider>
            <span class="text-subtitle-2 font-weight-bold" ref="password">{{
              $t('signup.password')
            }}</span>
            <validation-provider
              v-slot="{ errors }"
              name="password"
              :rules="{
                required: true,
                min: 8,
                regex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).*$/
              }"
            >
              <v-text-field
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :placeholder="$t('signup.passwordPlaceholder')"
                v-model.trim="password"
                :error-messages="errors"
                :hint="$t('signup.regexMessage')"
                @click:append="showPassword = !showPassword"
                @keyup.enter="focusNext($event.target)"
              ></v-text-field>
            </validation-provider>
            <span class="text-subtitle-2 font-weight-bold" ref="confirm">
              {{ $t('signup.confirmPassword') }}
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="confirm"
              rules="required|password:@password"
            >
              <v-text-field
                :type="showConfirm ? 'text' : 'password'"
                :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                :placeholder="$t('signup.passwordPlaceholder')"
                v-model="confirm"
                :error-messages="errors"
                @click:append="showConfirm = !showConfirm"
              ></v-text-field>
            </validation-provider>

            <!-- <span class="text-subtitle-2 font-weight-bold">{{
              $t('sms.phone')
            }}</span>

            <v-select
              color="#121212"
              :items="ctryCodes"
              v-model="inputCtryCode"
              required
              
              hide-details
              class="mb-1"
              @change="onChangeCtryCode"
              :readonly="isMatch"
            >
              <template slot="selection" slot-scope="{ item }">
                <div class="d-flex select-item">
                  {{ `${item.country} (+${item.code})` }}
                </div>
              </template>
              <template slot="item" slot-scope="{ item }">
                <div
                  class="d-flex select-item"
                  style="color:#121212 !important;"
                >
                  {{ `${item.country} (+${item.code})` }}
                </div>
              </template>
            </v-select>
            <validation-provider
              ref="phone"
              v-slot="{ errors }"
              name="phone"
              rules="required"
            >
              <v-text-field
                type="number"
                :placeholder="$t('sms.phonePlaceholder')"
                v-model="inputPhone"
                class="mb-1 phone-wrapper"
                hide-details
                
                @change="onChangePhone"
                @keypress="onKeydown"
                :readonly="isMatch"
              >
                <template slot="append">
                  <v-btn
                    class="px-2 rounded-r"
                    height="48px"
                    color="primary"
                    depressed
                    tile
                    @click="sendAuthSms"
                    :disabled="!isValidPhone || isMatch || sendSms"
                    >{{ $t('sms.codeBtn') }}</v-btn
                  >
                </template>
              </v-text-field>
              <validation-provider
                v-slot="{ errors: verifyErrors }"
                name="verifyCode"
                rules="required"
              >
                <v-text-field
                  type="number"
                  :placeholder="$t('sms.codePlaceholder')"
                  v-model="verifyCode"
                  class="verify-code-wrapper"
                  hide-details
                  
                  @change="onChangeVerifyCode"
                  :disabled="!sendSms"
                  :readonly="isMatch"
                >
                </v-text-field>
                <div style="min-height:14px;margin-bottom:8px;padding: 0 12px;">
                  <v-expand-transition>
                    <div
                      v-if="isMatch || sendSms"
                      class="d-flex flex-column text-caption success--text"
                      v-html="scsmsg"
                    ></div>
                  </v-expand-transition>
                  <v-expand-transition>
                    <div
                      v-if="errors[0] || verifyErrors[0] || errmsg"
                      class="d-flex flex-column text-caption error--text"
                      v-html="errors[0] || verifyErrors[0] || errmsg"
                    ></div>
                  </v-expand-transition>
                </div>
              </validation-provider>
            </validation-provider> -->

            <span class="text-subtitle-2 font-weight-bold">{{
              $t('signup.refferalCode')
            }}</span>
            <validation-provider
              ref="recommend"
              v-slot="{ errors }"
              name="recommend"
              rules=""
            >
              <v-text-field
                :placeholder="$t('signup.refferalCodePlaceholder')"
                v-model="recommend"
                :error-messages="errors"
                :clearable="params.code ? false : true"
                :readonly="params.code ? true : false"
              ></v-text-field>
            </validation-provider>

            <!-- <vue-recaptcha
              :sitekey="recaptchaKey"
              ref="recaptcha"
              @verify="onVerify"
              @expired="onExpired"
              :size="isCompact ? 'compact' : 'normal'"
            ></vue-recaptcha>
            <div class="text-caption error--text" ref="recap">
              {{ recaptchaError ? recaptchaError : '' }}
            </div> -->
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-btn
              class="font-weight-bold"
              tile
              fixed
              x-large
              style="width:50%;z-index: 5;left: 0;bottom: 0px;height: 56px;"
              to="/signin"
            >
              {{ $t('signup.back') }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              class="font-weight-bold bottom-disable-p"
              color="primary"
              tile
              fixed
              x-large
              style="width: 50%;z-index: 5;left: 50%;bottom: 0px;height: 56px;"
              type="submit"
              :disabled="loading || invalid"
            >
              {{ $t('signup.signup') }}
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
  </v-container>
</template>

<script>
import { required, email, regex, min } from 'vee-validate/dist/rules'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from 'vee-validate'
import VueRecaptcha from 'vue-recaptcha'
import countryCode from '@/configs/countryCode'

setInteractionMode('eager')

export default {
  data: () => ({
    email: '',
    password: '',
    confirm: '',
    recommend: '',
    recaptcha: false,
    recaptchaToken: '',
    recaptchaError: null,
    ctryCode: { country: 'South Korea', code: 82 },
    inputCtryCode: { country: 'South Korea', code: 82 },
    ctryCodes: [],
    phone: null,
    inputPhone: null,
    verifyCode: null,
    sendSms: false,
    totalTime: 3 * 60,
    timer: null,
    isMatch: false,
    isValidPhone: false,
    errmsg: '',
    scsmsg: '',
    showPassword: false,
    showConfirm: false,
    emailLoading: false,
    isValidEmail: false
  }),
  computed: {
    loading() {
      return this.$store.getters.loading
    },
    params() {
      return this.$route.params
    },
    recaptchaKey() {
      return process.env.VUE_APP_RECAPTCHA_KEY
    },
    isCompact() {
      return screen.width < 375
    },
    minutes() {
      const minutes = Math.floor(this.totalTime / 60)
      return this.padTime(minutes)
    },
    seconds() {
      const seconds = this.totalTime - this.minutes * 60
      return this.padTime(seconds)
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    VueRecaptcha
  },
  created() {
    extend('required', {
      ...required,
      message: this.$t('signup.requiredMessage')
    })
    extend('email', {
      ...email,
      message: this.$t('signup.emailMessage')
    })
    extend('password', {
      params: ['target'],
      validate(value, { target }) {
        return value === target
      },
      message: this.$t('signup.passwordMessage')
    })
    extend('regex', {
      ...regex,
      message: this.$t('signup.regexMessage')
    })
    extend('min', {
      ...min,
      message: this.$t('signup.regexMessage')
    })
    this.ctryCodes = countryCode
  },
  mounted() {
    this.$refs.form.reset()
    if (this.$route.params.code) this.recommend = this.$route.params.code
  },
  // watch: {
  //   totalTime(val) {
  //     if (val === 0 && !this.isMatch) {
  //       this.verifyCode = null
  //       this.$refs.phone.errors = ['인증시간이 초과되었습니다.']
  //       this.resetTimer()
  //       this.sendSms = false
  //     }
  //   }
  // },
  methods: {
    focusNext(elem) {
      const currentIndex = Array.from(elem.form.elements).indexOf(elem)
      elem.form.elements
        .item(
          currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0
        )
        .focus()
    },
    onVerify(r) {
      this.recaptcha = true
      this.recaptchaToken = r
      this.recaptchaError = ''
      // this.$refs.recaptcha.reset()
      // this.onSubmit()
    },
    onExpired() {
      this.recaptcha = false
      this.recaptchaToken = ''
      this.$refs.recaptcha.reset()
    },
    scrollTo(elem) {
      let target = this.$refs[elem]

      this.$vuetify.goTo(target)
    },
    // onChangeEmail() {
    //   this.$refs.email.validate().then((res) => {
    //     if (res.valid) {
    //       this.emailLoading = true

    //       const params = { email: this.email.trim().toLowerCase() }
    //       this.$store
    //         .dispatch('mailcheck', params)
    //         .then((res) => {
    //           this.emailLoading = false
    //           const data = res.data
    //           if (data.status) {
    //             this.isValidEmail = true
    //           } else {
    //             this.isValidEmail = false
    //             const code = data ? data.code : ''
    //             switch (code) {
    //               case 'mail_type':
    //               case 'domain':
    //               case 'unsafe':
    //                 this.$refs.email.errors = ['가입할 수 없는 메일입니다.']
    //                 break
    //               case 'joined':
    //                 this.$refs.email.errors = [
    //                   this.$t('signup.duplicateMessage')
    //                 ]
    //                 break
    //             }
    //           }
    //         })
    //         .catch((err) => {
    //           this.emailLoading = false
    //           this.isValidEmail = false
    //           this.$store.dispatch('toast', {
    //             toast: true,
    //             toast_msg: this.$t('errorServer'),
    //             timeout: 2000
    //           })
    //         })
    //     }
    //   })
    // },
    validPhone(phone) {
      const regx = /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/

      if (this.inputCtryCode.code === 82 && !regx.test(phone)) {
        this.isValidPhone = false
        this.errmsg = this.$t('sms.m01')
        return
      }
      if (
        this.inputCtryCode.code !== 82 &&
        (phone.length < 8 || phone.length > 15)
      ) {
        this.isValidPhone = false
        this.errmsg = this.$t('sms.m01')
        return
      }
      this.errmsg = ''

      this.isValidPhone = true
    },
    onKeydown(e) {
      if (
        e.keyCode === 101 ||
        e.keyCode === 69 ||
        e.keyCode === 45 ||
        e.keyCode === 43
      )
        e.preventDefault()
      if (this.inputCtryCode.code === 82 && e.target.value.length > 10)
        e.preventDefault()
      if (e.target.value.length > 14) e.preventDefault()
      this.validPhone(e.target.value)
    },
    // startTimer() {
    //   this.timer = setInterval(() => this.countdown(), 1000)
    // },
    // stopTimer() {
    //   clearInterval(this.timer)
    //   this.timer = null
    // },
    // resetTimer() {
    //   this.totalTime = 3 * 60
    //   clearInterval(this.timer)
    //   this.timer = null
    // },
    // padTime(time) {
    //   return (time < 10 ? '0' : '') + time
    // },
    // countdown() {
    //   if (this.totalTime >= 1) {
    //     this.totalTime--
    //   } else {
    //     this.totalTime = 0
    //     this.resetTimer
    //   }
    // },
    sendAuthSms() {
      if (!this.inputPhone) {
        this.$refs.phone.errors = [this.$t('sms.phonePlaceholder')]
        return
      }
      if (!this.isValidEmail) {
        this.$refs.email.errors = ['이메일을 먼저 확인해주세요.']
        return
      }
      this.$store.commit('loading', true)
      this.$refs.phone.errors = []
      // this.resetTimer()
      this.ctryCode = this.inputCtryCode
      this.phone = this.inputPhone
      const params = {
        email: this.email.trim(),
        phone: this.phone,
        country: this.ctryCode.code
      }
      // console.log(params, this.sendSms)

      this.$store
        .dispatch('auth_sms', params)
        .then((res) => {
          this.$store.commit('loading', false)
          if (res.data && res.data.result) {
            this.sendSms = true
            // console.log(res, this.sendSms)
            // this.startTimer()
            this.$refs.phone.errors = []
            this.scsmsg = `<span>${this.$t('sms.m02')}</span><span>${this.$t(
              'sms.m03'
            )}</span>`
            this.errmsg = `<span>${this.$t('sms.m04')}</span>`
          } else if (res.data && res.data.code === 'invalid_sms') {
            this.$refs.phone.errors = []
            this.sendSms = true
            this.scsmsg = `<span>${this.$t('sms.m05')}</span>
            <span>${this.$t('sms.m03')}</span>`
            this.errmsg = `<span>${this.$t('sms.m04')}</span>`
          } else throw res
        })
        .catch((err) => {
          this.$store.commit('loading', false)
          // console.log(err)
          this.$refs.phone.errors = []
          this.errmsg = ''
          if (err.data && err.data.code === 'duplicate') {
            this.$refs.phone.errors = [this.$t('sms.m06')]
          } else if (err.data && err.data.code === 'limit_day') {
            this.errmsg = `<span>${this.$t('sms.m07')}</span>
            <span>${this.$t('sms.m08')}</span>`
          } else if (err.data && err.data.code === 'auth_mail') {
            this.errmsg = `<span>${this.$t('sms.m09')}</span>`
          } else if (err.data && err.data.code === 'phone_type') {
            this.errmsg = `<span>${this.$t('sms.m01')}</span>`
          } else if (err.data && err.data.code === 'fail_sms') {
            this.errmsg = `<span>${this.$t('sms.m15')}</span><span>${this.$t(
              'sms.m16'
            )}</span>`
          } else {
            this.$refs.phone.errors = [this.$t('sms.m10')]
          }
        })
    },
    onChangeCtryCode() {
      if (this.inputPhone) {
        this.validPhone(this.inputPhone)
      }
      if (this.inputCtryCode !== this.crtyCode) {
        // this.resetTimer()
        this.$refs.phone.errors = [this.$t('sms.m11')]
        this.sendSms = false
        this.verifyCode = null
        this.isMatch = false
      }
    },
    onChangePhone() {
      this.validPhone(this.inputPhone)
      if (this.inputPhone !== this.phone) {
        // this.resetTimer()
        this.$refs.phone.errors = [this.$t('sms.m11')]
        this.sendSms = false
        this.verifyCode = null
        this.isMatch = false
      }
    },
    onChangeVerifyCode() {
      // if (!this.timer) {
      //   this.verifyCode = null
      // }
      this.$store.commit('loading', true)
      if (this.sendSms && this.verifyCode) {
        const params = {
          email: this.email.trim(),
          phone: this.phone,
          country: this.ctryCode.code,
          auth_input: this.verifyCode
        }
        // console.log(params)
        this.$store
          .dispatch('auth_sms_confirm', params)
          .then((res) => {
            this.$store.commit('loading', false)
            this.$refs.phone.errors = []
            this.errmsg = ''
            // console.log(res)
            if (res.data && res.data.result) {
              this.isMatch = true
              this.scsmsg = `<span>${this.$t('sms.m12')}</span>`
            } else {
              this.isMatch = false

              if (res.data && res.data.code === 'not_match')
                this.$refs.phone.errors = [this.$t('sms.m13')]
              else if (res.data && res.data.code === 'different')
                this.$refs.phone.errors = [this.$t('sms.m14')]
              else throw res
            }
          })
          .catch((err) => {
            console.log(err)
            this.$store.commit('loading', false)
            this.isMatch = false
            this.$store.dispatch('toast', {
              toast: true,
              toast_msg: this.$t('errorServer'),
              timeout: 2000
            })
          })
      } else {
        this.errmsg = ''
        this.$store.commit('loading', false)
        this.$refs.phone.errors = [this.$t('sms.m11')]
      }
    },
    onSubmit() {
      this.$refs.observer
        .validate()
        .then((response) => {
          // console.log(this.email, response)
          if (!response) {
            // console.log(response);
          } else {
            // if (!this.recaptcha) {
            //   const element = this.$refs['recap']
            //   const top = element.offsetTop
            //   // console.log(top)
            //   this.$vuetify.goTo(top)
            //   this.recaptchaError = this.$t('signup.requiredMessage')
            // } else {
            const params = {
              email: this.email.trim().toLowerCase(),
              password: this.password.trim(),
              recommend: this.recommend ? this.recommend.trim() : '',
              recaptcha: this.recaptchaToken
            }
            this.$store.commit('loading', true)
            this.$store.dispatch('SIGNUP', params).then((res) => {
              this.$store.commit('loading', false)
              if (res.data) {
                if (res.data.status) {
                  this.$router.replace({
                    name: 'verify',
                    params: { email: params.email }
                  })
                } else if (res.data.code === 'duplicate') {
                  this.$refs.email.errors = this.$t('signup.duplicateMessage')
                } else if (res.data.code === 'block_mail') {
                  this.$refs.email.errors = '가입할 수 없는 메일입니다.'
                } else if (res.data.code === 'phone') {
                  this.verifyCode = null
                  this.isMatch = false
                  this.sendSms = false
                  // this.resetTimer()
                  this.$refs.phone.errors = [this.$t('sms.m06')]
                } else if (res.data.code.indexOf('recommend') !== -1) {
                  this.$refs.recommend.errors = this.$t(
                    'signup.recommendMessage'
                  )
                } else if (res.data.code.indexOf('withdraw') !== -1) {
                  this.$refs.email.errors = this.$t('signup.withdrawMessage')
                } else {
                  //기타 오류 처리
                  // console.log(res);
                  throw response
                }
              } else throw response
            })
          }
          // }
        })
        .catch((error) => {
          console.log(error)
          this.$store.commit('loading', false)
          this.$store.dispatch('toast', {
            toast: true,
            toast_msg: this.$t('errorServer'),
            timeout: 2000
          })
        })
    }
  }
}
</script>

<style scoped>
.phone-wrapper >>> .v-input__append-outer {
  margin: 0 !important;
}
.phone-wrapper >>> .v-input__slot {
  padding-right: 0 !important;
}
/* .verify-code-wrapper >>> .v-messages__message {
  color: #f65b5b !important;
} */
</style>
